var hostAxes = [
  "vertical",
  "horizontal"
];
var hostAlignments = [
  "leading",
  "center",
  "trailing"
];
var zStackAlignments = [
  "topLeading",
  "top",
  "topTrailing",
  "leading",
  "center",
  "trailing",
  "bottomLeading",
  "bottom",
  "bottomTrailing"
];
export {
  hostAlignments,
  hostAxes,
  zStackAlignments
};
//# sourceMappingURL=containerTypes.js.map
